@if (selectedState) {
  <div class="sticky full-height">
    <div class="grid-x">
      <div class="cell small-5">
        <div class="button-menu-container">
          <button class="button-menu-first" aria-label="Show Add Options" (click)="toggleDropDown()">
            <span>Add</span><span class="down-arrow-combined">&#9662;</span>
          </button>
          @if (showAddDropdown) {
            <div class="button-menu-options-container" (focusout)="closeButtonMenu($event)">
              <button (click)="addNewFormPage('input')">Page</button>
              <button (click)="addNewFormPage('summary')">Summary Page</button>
              <button (click)="addNewFormPage('newCasingPlan')">Proposed Casing Plan</button>
              <button (click)="addNewFormPage('editCasingPlan')">Edit Casing Plan</button>
              <button (click)="addSection()">Section</button>
            </div>
          }
        </div>
      </div>
      <div class="cell small-7">
        <div class="button-menu-container align-right">
          <button class="button-menu-first" aria-label="Show Add Options" (click)="toggleRuleDropDown()">
            <span>Rules</span><span class="down-arrow-combined">&#9662;</span>
          </button>
          @if (showRuleDropdown) {
            <div class="button-menu-options-container right" (focusout)="closeButtonMenu($event)">
              <button (click)="showRuleEditor()">Form</button>
              <button (click)="editSectionValidation()">Section</button>
            </div>
          }
        </div>
      </div>
    </div>
    <ul class="tabs border-none margin-top">
      <li class="no-margin">
        <button (click)="setMode('section')" class="tabs-title padded" [class.is-active]="tabMode === 'section'">Sections</button>
      </li>
      <li>
        <button (click)="setMode('page')" class="tabs-title padded" [class.is-active]="tabMode === 'page'">Pages</button>
      </li>
      <li class="no-margin">
        <button (click)="setMode('row')" class="tabs-title padded" [class.is-active]="tabMode === 'row'">Rows</button>
      </li>
    </ul>
    <div class="sb-outline-scroll-container">
      <!-- rows -->
      @if (tabMode === 'row') {
        <div>
          @for (section of selectedState.sections; track section; let s = $index) {
            <div class="sb-outline-section-container" [ngClass]="{'active': section.id === _currentSection?.id }"
              id="section{{s}}">
              <section aria-label="Section Data Container">
                @if (!section.isEditing) {
                  <div class="sb-outline-section-title" (click)="setActiveSection(section)" [ngClass]="{'active': section.id === _currentSection?.id }">
                    <button class="arrow-up" (click)="toggleSectionPages(s, $event)" [ngClass]="{'display-inline-block' : s == 0}">&#x25B2;</button>
                    <button class="arrow-dwn" (click)="toggleSectionPages(s, $event)" [ngClass]="{'display-inline-block' : s != 0}">&#x25BC;</button>
                    <span class="title-trimmed" [ngClass]="{'sb-outline-placeholder': !section.name}">{{section.name ? section.name : "Enter Section Title"}}</span>
                    <button (click)="deleteSection(section, $event)" class="float-right minor-margin-right" [ngStyle]="{'display-block': (section.id === _currentSection?.id) ? 'inherit' : 'none'}">
                      <svg-icon icon="icon-trash" class="tiny" attr.title="Delete Section {{section.name ? section.name : 'Enter Section Title'}}"></svg-icon>
                    </button>
                    <button (click)="editSectionName(section, $event)" class="float-right minor-margin-right" [ngStyle]="{'display-block': (section.id === _currentSection?.id) ? 'inherit' : 'none'}">
                      <svg-icon icon="icon-pencil" class="tiny" attr.title="Edit Section {{section.name ? section.name : 'Enter Section Title'}}"></svg-icon>
                    </button>
                  </div>
                }
                @if (section.isEditing) {
                  <div class="flex sb-outline-section-title active">
                    <input type="text" class="no-margin white-bg" [(ngModel)]="sectionName" />
                    <button (click)="saveSectionName(section)" class="minor-margin-left flex-item v-align">
                      <svg-icon icon="icon-save" class="tiny" title="Save Section Name"></svg-icon>
                    </button>
                  </div>
                }
              </section>
              @for (page of section.pages; track page; let i = $index) {
                <div class="sb-outline-page-row-container" [ngClass]="{'display-block': s == 0}">
                  <button class="sb-outline-page-button full-width" (click)="setActivePage(page)" [attr.data-pageid]="page.pageNumber" [ngClass]="{'active': _currentPage.pageNumber === page.pageNumber,'sb-outline-placeholder': page.subtitle == ''}">
                    {{page.subtitle == '' ? pageTitlePlaceholder : page.subtitle}}
                  </button>
                  @if (_currentPage.pageNumber === page.pageNumber) {
					<div cdkDropList [cdkDropListData]="page.questions" (cdkDropListDropped)="onQuestionRowDrop($event, page)">
                      @for (row of page.questions; track row; let i = $index) {
                        <div class="sb-outline-sort-row" cdkDrag>
                          <section aria-label="Question Context Container">
                            @for (question of row; track question) {
                              <div [ngClass]="{'empty-prompt item-label has-border': question.label === ''}" [attr.data-id]="question.key" title="{{question.contextTarget || question.type}}">
                                @if (question.contextTarget != null && question.contextTarget != '' && rulesEditorShowing) {
                                  <button (click)="copyContext(question.contextTarget)" class="float-left minor-margin-right">
                                    <svg-icon icon="icon-clipboard" title="Copy to Clipboard" class="tiny vertical-align-middle"></svg-icon>
                                  </button>
                                }
                                @if (question.contextTarget || question.type) {
                                  <div class="sb-outline-sort-row-question" [innerHTML]="question.contextTarget || question.type"></div>
                                }
                                @if (!question.contextTarget && !question.type) {
                                  <span>Empty cell</span>
                                }
                              </div>
                            }
                          </section>
                          <section aria-label="Question Reorder Container">
                            <button attr.aria-label="Reorder Row" title="Reorder Row" cdkDragHandle>
                              <svg-icon icon="icon-up-down-drag" class="handle tiny cursor-grab"></svg-icon>
                            </button>
                          </section>
                        </div>
                      }
                    </div>
                  }
                </div>
              }
            </div>
          }
        </div>
      }
      <!-- pages -->
      @if (tabMode === 'page') {
        <div cdkDropListGroup>
        @for (section of selectedState.sections; track section) {
          <div class="sb-outline-section-container" [ngClass]="{'active': section.id === _currentSection?.id }">
            <section aria-label="Section Data Container">
              <button (click)="setActiveSection(section)" class="sb-outline-section-title full-width text-left title-trimmed" [ngClass]="{'active': section.id === _currentSection?.id, 'sb-outline-placeholder': !section.name }">
                {{section.name ? section.name : "Enter Section Title"}}
              </button>
            </section>
			    <div [id]="'sectionPageList-' + section.id" cdkDropList [cdkDropListData]="section.pages" (cdkDropListDropped)="onPageDrop($event, section)">
              @for (page of section.pages; track page; let i = $index) {
                <div (click)="setActivePage(page)" class="sb-outline-sort-row sb-outline-page-button grid-x" [ngClass]="{'active': _currentPage.pageNumber === page.pageNumber}" (drop)="onPageDrop(page, $event)">
                  <div class="cell auto">
                    <button title="{{page.subtitle}}" attr.aria-label="Set Page Active {{page.subtitle}}" class="sb-outline-sort-row-page" [attr.title]="page.emptyDisplayName ? 'enter page title' : page.subtitle" [ngClass]="{'empty-prompt page-title has-border': page.emptyDisplayName,'sb-outline-placeholder': page.subtitle == ''}">
                      {{page.subtitle == '' ? pageTitlePlaceholder : page.subtitle}}
                    </button>
                  </div>
                  <div class="cell shrink">
                    <button class="handle" title="Reorder Page" attr.aria-label="Drag To Reorder Page {{page.subtitle}}" cdkDragHandle>
                      <svg-icon icon="icon-up-down-drag" class="tiny cursor-grab" aria-hidden="true" title="Reorder Page"></svg-icon>
                    </button>
                  </div>
                  <div class="cell shrink">
                    <button title="Delete Page" attr.aria-label="Delete Page {{page.subtitle}}" (click)="deletePage(section, page)" [disabled]="section.pages.length === 1">
                      <svg-icon icon="icon-trash" class="tiny" aria-hidden="true"></svg-icon>
                    </button>
                  </div>
                </div>
              }
            </div>
          </div>
        }
        </div>
      }
      <!-- section -->
      @if (tabMode === 'section') {
        <!--<div [dragula]="selectedState.sections" [dragulaModel]="selectedState.sections">-->
		<div cdkDropList [cdkDropListData]="selectedState.sections" (cdkDropListDropped)="onSectionDrop($event)">
          @for (section of selectedState.sections; track section) {
            <div class="sb-outline-section-title sb-outline-section-container grid-x no-shadow" (click)="setActiveSection(section)" [ngClass]="{'active': sectionIsActive(section.id), 'sb-outline-placeholder': !section.name }" cdkDrag>
              <div class="cell auto text-left title-trimmed">
                {{section.name ? section.name : "Enter Section Title"}}
              </div>
              <div class="cell shrink handle" title="Reorder Sections" attr.aria-label="Drag to Reorder Section {{section.name}}">
                <button cdkDragHandle>
                  <svg-icon icon="icon-up-down-drag" class="tiny cursor-grab" aria-hidden="true" title="Reorder Section"></svg-icon>
                </button>
              </div>
            </div>
          }
        </div>
      }
    </div>
  </div>
}
